import { render, staticRenderFns } from "./other-make-appointments.vue?vue&type=template&id=05b64b76&"
import script from "./other-make-appointments.vue?vue&type=script&lang=js&"
export * from "./other-make-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports